export const CREATE_DISCOUNT_RULE = 'CREATE_DISCOUNT_RULE'
export const GET_LIST_DISCOUNT_RULE = 'GET_LIST_DISCOUNT_RULE'
export const DETAIL_DISCOUNT_RULE = 'DETAIL_DISCOUNT_RULE'
export const PATCH_DISCOUNT_RULE = 'PATCH_DISCOUNT_RULE'
